<template>
  <div>
    <el-dialog
      top="10vh"
      width="800px"
      center
      :title="isEdit ? '修改' : '创建'"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      @close="HandleCancel"
    >
      <el-form :rules="rules" :model="editData" :ref="form" label-width="140px">
        <el-row>
          <el-col :span="12">
            <el-form-item prop="name" label="帐户名">
              <el-input style="width: 230px" v-model.trim="editData.name" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              class="filterable-tips"
              prop="bankCode"
              label="银行代码"
            >
              <el-select
                filterable
                style="width: 230px"
                v-model="editData.bankCode"
              >
                <el-option
                  v-for="option in bankOptions"
                  :disabled="!option.canChoose"
                  :key="option.bankCode"
                  :label="`${option.bankName} (${option.bankCode})`"
                  :value="option.bankCode"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="bankCardNumber" label="银行卡卡号">
              <el-input
                style="width: 230px"
                v-model.trim="editData.bankCardNumber"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="buildNo" label="安全码">
              <el-input style="width: 230px" v-model.trim="editData.buildNo" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="bankCardType" label="银行卡类型">
              <el-select style="width: 230px" v-model="editData.bankCardType">
                <el-option
                  v-for="option in bankCardTypeOptions"
                  :key="option.key"
                  :label="option.label"
                  :value="option.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="phoneNumber" label="手机号码">
              <el-input
                style="width: 230px"
                v-model.trim="editData.phoneNumber"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="userInfo.userType === 'admin'">
            <el-form-item prop="errorDescription" label="错误描述">
              <el-input
                style="width: 230px"
                v-model="editData.errorDescription"
              />
            </el-form-item>
          </el-col>
          <!-- <el-col :span="12">
            <el-form-item prop="userIdNo" label="身份证字号">
              <el-input style="width: 230px" v-model.trim="editData.userIdNo" />
            </el-form-item>
          </el-col>
          </el-col> -->
          <el-col :span="12">
            <el-form-item prop="onlineBankingUsername" label="手机银行帐号">
              <el-input
                style="width: 230px"
                v-model.trim="editData.onlineBankingUsername"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="dispatchMode" label="派单模式">
              <template v-if="!editData.isManualUser">
                <template v-if="editData.dispatchMode !== 2">
                  <el-select
                    style="width: 230px"
                    v-model="editData.dispatchMode"
                  >
                    <el-option
                      v-for="option in dispatchModeOptions"
                      :key="option.value"
                      :label="option.label"
                      :value="option.value"
                    >
                    </el-option>
                  </el-select>
                </template>
                <el-tag v-else size="small" type="success">转换中</el-tag>
              </template>
              <template v-else>手动</template>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="onlineBankingPassword" label="手机银行登录密码">
              <el-input
                style="width: 230px"
                v-model.trim="editData.onlineBankingPassword"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              prop="onlineBankingPayPassword"
              label="手机银行支付密码"
            >
              <el-input
                style="width: 230px"
                v-model.trim="editData.onlineBankingPayPassword"
              />
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item label="开户银行网点">
              <el-col :span="5">
                <el-form-item prop="bankProvince">
                  <el-select
                    filterable
                    clearable
                    placeholder="省"
                    @change="changeProvince"
                    v-model="editData.bankProvince"
                  >
                    <el-option
                      v-for="option in regionsInfo"
                      :key="option.province"
                      :label="option.province"
                      :value="option.province"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="1">&nbsp;</el-col>
              <el-col :span="5">
                <el-form-item prop="bankCity">
                  <el-select
                    filterable
                    clearable
                    placeholder="市"
                    v-model="editData.bankCity"
                  >
                    <el-option
                      v-for="i in findCity"
                      :key="i.name"
                      :label="i.name"
                      :value="i.name"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="1">&nbsp;</el-col>
              <el-col :span="12">
                <el-form-item prop="bankBranch">
                  <el-input clearable v-model="editData.bankBranch" />
                </el-form-item>
              </el-col>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item v-if="isEdit" label="头像">
              <el-image
                style="width: 120px; height: 120px; border-radius: 10px"
                :src="editData.faceImgPath || ''"
              >
                <!-- <div slot="error" class="image-slot">
                  <i class="el-icon-picture-outline"></i>
                </div> -->
              </el-image>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="备注">
              <el-input
                type="textarea"
                :autosize="{ minRows: 3, maxRows: 5 }"
                v-model="editData.remark"
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button round @click="HandleCancel()"> 取消 </el-button>
        <el-button
          :loading="loading"
          round
          type="success"
          @click="HandleVaild()"
        >
          保存
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import mainCommon from "@/utils/mainCommon";
import varCommon from "@/utils/varCommon";
import { addBank, editBank } from "@/api/bank";
import { getRegionsInfo } from "@/api/setting";

export default {
  mixins: [mainCommon],
  props: ["modules"],
  data() {
    return {
      bankOptions: [],
      loading: false,
      form: "form",
      rules: {
        bankBranch: [{ required: true, message: "必填项目不可为空" }],
        bankCardNumber: [
          {
            required: true,
            message: "银行卡号格式不符",
            pattern: /^[0-9]+$/,
          },
        ],
        buildNo: [
          {
            message: "安全码格式不符",
            pattern: /^$|^[0-9]{9}$/, // 允许空或是数字
          },
        ],
        bankCode: [{ required: true, message: "必填项目不可为空" }],
        // userIdNo: [{ required: true, message: "必填项目不可为空" }],
        name: [{ required: true, message: "必填项目不可为空" }],
        // onlineBankingPassword: [
        //   {
        //     required: true,
        //     message: "格式不符或必填项目为空",
        //     pattern: /^[a-zA-Z0-9~`!@#$%^&*()--+={}[\]|\\:;"'<>,.?/_]{3,}$/g,
        //   },
        // ],
        // onlineBankingPayPassword: [
        //   {
        //     required: true,
        //     message: "格式不符或必填项目为空",
        //     pattern: /^[a-zA-Z0-9~`!@#$%^&*()--+={}[\]|\\:;"'<>,.?/_]{3,}$/g,
        //   },
        // ],
        // onlineBankingUsername: [
        //   { required: true, message: "必填项目不可为空" },
        // ],
        phoneNumber: [{ required: true, message: "必填项目不可为空" }],
        bankProvince: [{ required: true, message: "必填项目不可为空" }],
        bankCity: [{ required: true, message: "必填项目不可为空" }],
        dispatchMode: [{ required: true, message: "必填项目不可为空" }],
        cd: [
          {
            required: true,
            message: "格式不符或必填项目为空",
            pattern: /^\d+$/g,
          },
        ],
      },
      regionsInfo: null,
      dispatchModeOptions: [
        {
          label: "自动",
          value: 0,
        },
        {
          label: "手动",
          value: 1,
        },
      ],
      bankCardTypeOptions: varCommon.bankCardTypeOptions, // 银行卡类型
    };
  },
  computed: {
    // 根据选择省回传市
    findCity() {
      if (this.editData.bankProvince) {
        try {
          return this.regionsInfo.find(
            (o) => o.province === this.editData.bankProvince
          ).cities;
        } catch (e) {
          return "";
        }
      } else {
        return "";
      }
    },
    editData() {
      return this.$store.state[this.modules].editData;
    },
    isEdit() {
      return this.editData.accId ? true : false;
    },
    dialogVisible: {
      get() {
        if (this.$store.state[this.modules].dialogVisible) {
          this.GetRegionsInfo();
          this.getBankLists();
        }
        return this.$store.state[this.modules].dialogVisible;
      },
      set(val) {
        this.HandleSetState(this.modules, "/SET_STATE", { dialogVisible: val });
      },
    },
  },
  methods: {
    getBankLists() {
      this.$store
        .dispatch("ToggleBankLists", { userId: this.userInfo.userId })
        .then((res) => {
          this.bankOptions = res;
        });
    },
    HandleCancel() {
      this.$refs[this.form].resetFields();
      this.$store.commit(`${this.modules}/SET_DEFAULT`);
      this.HandleSetState(this.modules, "/SET_STATE", { dialogVisible: false });
    },
    HandleVaild() {
      this.$refs[this.form].validate((valid) => {
        if (valid) this.HandleSubmit();
      });
    },
    HandleSubmit() {
      this.loading = true;
      // this.editData.id = this.editData.userIdNo;

      // 如果为纯手动，固定传 1
      if (this.editData.isManualUser) {
        this.editData.dispatchMode = 1;
      }

      if (!this.editData.accId) {
        addBank(this.editData)
          .then((res) => {
            this.$notify.success(res.message);
            this.HandleCancel();
            this.$emit("HandleGetList");
          })
          .catch(() => {})
          .finally(() => {
            this.loading = false;
          });
      } else {
        editBank(this.editData)
          .then((res) => {
            this.$notify.success(res.message);
            this.HandleCancel();
            this.$emit("HandleGetList");
          })
          .catch(() => {})
          .finally(() => {
            this.loading = false;
          });
      }
    },
    // 取得地区讯息
    GetRegionsInfo() {
      getRegionsInfo().then((res) => {
        this.regionsInfo = res.data;
      });
    },
    // 省改变，直接清空市
    changeProvince() {
      this.editData.bankCity = "";
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/views/account/bank/Dialog.vue